import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { AlertTriangle, RefreshCw, ExternalLink } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const BreakingNewsSection = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchNews = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${API}/news/breaking`);
      setNews(data);
    } catch {
      setNews([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchNews();
    const interval = setInterval(fetchNews, 5 * 60 * 1000); // Refresh every 5 mins
    return () => clearInterval(interval);
  }, [fetchNews]);

  return (
    <div className="content-card content-card-large breaking-news-card" data-testid="breaking-news-section">
      <div className="card-header breaking-news-header">
        <h2>
          <AlertTriangle size={20} className="inline breaking-icon" /> Breaking News
        </h2>
        <button className="section-action-btn" onClick={fetchNews} title="Refresh">
          <RefreshCw size={16} className={loading ? 'spinning' : ''} />
        </button>
      </div>
      <div className="card-content">
        {loading && news.length === 0 ? (
          <div className="loading-placeholder">Loading breaking news...</div>
        ) : news.length === 0 ? (
          <div className="empty-state">No breaking news at this time</div>
        ) : (
          <ul className="breaking-news-list" data-testid="breaking-news-list">
            {news.map((item, idx) => (
              <li key={`breaking-${idx}-${item.title?.slice(0,20)}`} className="breaking-news-item">
                <a 
                  href={item.link} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="breaking-link"
                  data-testid={`breaking-news-item-${idx}`}
                >
                  <span className="breaking-title">{item.title}</span>
                  <ExternalLink size={14} className="ext-icon" />
                </a>
                {item.summary && (
                  <p className="breaking-summary">{item.summary}</p>
                )}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default BreakingNewsSection;
